<span [style.font-size.px]="_settings.textSize">
	<span *ngIf="beforeText" class="beforeText" [innerHTML]="beforeText"></span>
	<span
		[style.font-size.px]="_settings.valueTextSize"
		class="value"
		[innerHTML]="_valueStr"
	></span>
	<span *ngIf="afterText" class="afterText" [innerHTML]="afterText"></span>
</span>
